// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + "." + "8470e03671727a9d0cdc" + ".css";
};